import { createFileRoute } from '@tanstack/react-router';

import { CampaignsPage } from '@/features/attribution/pages/campaigns';

export const Route = createFileRoute('/_app/settings/campaigns')({
  component: CampaignsPage,
});
